// extracted by mini-css-extract-plugin
module.exports = {"company":"VoYx4ctB-Xw0l2jFe7IcK","paragraph":"P9bUSTgM4EJBrjoqvrwHB","comapniesLogos":"_1ZMETfNjSGg2b8duYPNwna","logo":"xVj2ACKIMs4scRhhjMtaT","row":"_3qVK406tza7JaYMx0heM_a"};